// "Warden of the Proving Grounds." The QA testers' title. Same shape
// as the founder title (see founderTitle.js): granted server-side via
// the `is_qa_tester` column, which the server derives from the `qa`
// staff role, so the client only ever displays it when the player
// object carries `isQaTester: true` and it cannot be forged by a
// tampered client.
//
// Unlike the crowns, the label and the epithet differ: the badge is
// named for the role ("Warden of the Proving Grounds") while the line
// that renders under the username is the epithet, matching how the
// crowns read as a byline ("misprintedChris, Walker of Halls Unbuilt").
//
// QA_PICKER_SENTINEL is what we store in the crown picker's column
// (`displayed_crown_avatar_id`) when a QA tester picks this title.
// PlayerTitle.jsx recognises the sentinel and renders the title
// regardless of any held crowns.

export const QA_TITLE_LABEL = 'Warden of the Proving Grounds';
export const QA_TITLE_EPITHET = 'Walker of Halls Unbuilt';
export const QA_PICKER_SENTINEL = '__qa__';
